// extracted by mini-css-extract-plugin
export default {"faqContainer":"Sm251jACCESeMpmupz2Y","faqItem":"FU6cCR0MkgiyvLmn7Iyg"};